<div class="item-payment-totals" [class.standalone]="standalone">
  @if(itemGroups && order){
  <div class="item-groups">

    <div class="group">

      <div class="line group-delivery-total">
        <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/container 8.svg"
            alt="express_shipping">Free shipping</span>
        <span class="value">
          0 kr
        </span>
      </div>

      <div class="line group-delivery-total">
        <span class="label"><img class="mr-8-px"
            src="./../../../../../assets/images/product/shipping/local_shipping.svg"
            alt="express_shipping">Delivery</span>
        <span class="value">
          @if(order.shippingWithTax | formatPrice | async; as shippingWithTax){
            @if(order.shippingLines[0]?.shippingMethod?.customFields?.payOnDelivery){
              <ng-container>Pay on delivery</ng-container>
            } @else {
              {{shippingWithTax}}
            }
          } @else {
          -
          }
        </span>
      </div>

      @if(order?.discounts?.length > 0){
      <div class="line group-items-total" [class.discounted-line]="true">
        <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg"
            alt="express_shipping">{{order.totalQuantity}} items</span>
        <span class="value">
          @if((order.subTotalWithTax-order?.discounts[0]?.amountWithTax) | formatPrice | async; as subTotalPriceBeforeDiscount){
          {{subTotalPriceBeforeDiscount}}
          } @else {
          -
          }
        </span>
      </div>
      <div class="line group-items-total">
        <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg"
            alt="express_shipping">{{order.totalQuantity}} items @if(order?.discounts?.length > 0){after
          discounts}</span>
        <span class="value">
          @if((order.subTotalWithTax) | formatPrice | async; as subTotalPrice){
          {{subTotalPrice}}
          } @else {
          -
          }
        </span>
      </div>
      } @else {
      <div class="line group-items-total">
        <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg"
            alt="express_shipping">{{order.totalQuantity}} items</span>
        <span class="value">
          @if(order.subTotalWithTax | formatPrice | async; as subTotalPrice){
          {{subTotalPrice}}
          } @else {
          -
          }
        </span>
      </div>
      }


    </div>

    <!--
      <div class="group">
        <div class="line group-delivery-total">
          <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/flight_takeoff.svg" alt="express_shipping">Express shipping</span>
          <span class="value">3.000 kr</span>
        </div>
        <div class="line group-items-total" [class.discounted-line]="true">
          <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg" alt="express_shipping">11 items</span>
          <span class="value">275.000</span>
        </div>
        @if (true) {
          <div class="line group-items-total">
            <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg" alt="express_shipping">11 items after discounts</span>
            <span class="value">220.000</span>
          </div>
        }
      </div>
 
      <div class="group">
        <div class="line group-delivery-total">
          <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/container 8.svg" alt="express_shipping">Free shipping</span>
          <span class="value">0.00 kr</span>
        </div>
        <div class="line group-items-total">
          <span class="label"><img class="mr-8-px" src="./../../../../../assets/images/product/benefits/box.svg" alt="express_shipping">6 items</span>
          <span class="value">150.000</span>
        </div>
      </div>
    -->
  </div>
  }

  <div class="totals">


    @if(order?.discounts?.length > 0){
    <div class="line total-line" [class.discount]="order?.discounts?.length > 0">
      <span class="label">Total</span>
      <span class="value">
        @if((order?.totalWithTax-order?.discounts[0]?.amountWithTax) | formatPrice | async; as totalPriceBeforeDiscount){
        {{totalPriceBeforeDiscount}}
        } @else {
        -
        }

      </span>
    </div>
    <div class="line total-line">
      <span class="label">Coupon discount</span>
      <span class="value">
        @if((order?.discounts[0]?.amountWithTax) | formatPrice | async; as discountAmount){
        {{discountAmount}}
        }
      </span>
    </div>
    <div class="line total-line">
      <span class="label">Total after discount</span>
      <span class="value">
        @if((order?.totalWithTax) | formatPrice | async; as totalPrice){
        {{totalPrice}}
        } @else {
        -
        }
      </span>
    </div>
    } @else {
    <div class="line total-line" [class.discount]="order?.discounts?.length > 0">
      <span class="label">Total</span>
      <span class="value">
        @if(order?.totalWithTax | formatPrice | async; as totalPrice){
        {{totalPrice}}
        } @else {
        -
        }

      </span>
    </div>
    }





  </div>

</div>
